export enum TicketActions {
  OPEN_TICKET_DETAILS,
  CLOSE_MODAL,
  CLOSE_DIALOG,
  OPEN_MODAL,
  SELECT,
}
